import { numericExtent, vwmaSeries } from "../utils";
const VWMA = {
    name: "VWMA",
    compute: (bars, period = 20) => vwmaSeries(bars, period),
    computeExtents: (values) => numericExtent(values),
    render: () => undefined,
};
export default VWMA;
